import { View } from "../base";
import { InputField, DropdownField } from "../base";

export type ErrorFallbackConfigFormData = {
  errorFallbackType?: string;
  errorFallbackValue?: string;
  errorFallbackTimeoutSeconds?: number;
  errorFallbackOccurrenceThreshold?: number;
  errorFallbackTimeWindowSeconds?: number;
};

type ErrorFallbackConfigFormProps = {
  config: ErrorFallbackConfigFormData;
  onChange: (key: string) => (value: unknown) => void;
};

export const ErrorFallbackConfigForm = ({ config, onChange }: ErrorFallbackConfigFormProps) => {
  return (
    <View className="flex flex-col gap-4">
      <DropdownField
        label="Error Fallback Type"
        placeholder="Select fallback type"
        value={config?.errorFallbackType || ""}
        onChange={onChange("errorFallbackType")}
        options={[
          { label: "Disabled", value: "" },
          { label: "Phone", value: "phone" },
          { label: "Webhook", value: "webhook" },
        ]}
      />

      <InputField
        label="Error Fallback Value"
        placeholder={config?.errorFallbackType === "phone" ? "Enter phone number" : "Enter webhook URL"}
        value={config?.errorFallbackValue || ""}
        onChange={onChange("errorFallbackValue")}
        isDisabled={!config?.errorFallbackType}
      />

      <InputField
        label="Error Fallback Timeout"
        tooltip="The timeout in seconds before the error fallback is triggered. A value of 0 results in no fallback being triggered."
        placeholder="Enter seconds"
        value={config?.errorFallbackTimeoutSeconds ?? 0}
        onChange={(value) => onChange("errorFallbackTimeoutSeconds")(value === "" || value === null || value === undefined ? null : Number(value))}
        type="number"
        min={0}
        max={30}
        isDisabled={!config?.errorFallbackType}
      />

      <InputField
        label="Error Fallback Occurrence Threshold"
        tooltip="Number of timeout occurrences across different sessions/calls within the time window before triggering fallback. Default: 5"
        placeholder="Enter threshold"
        value={config?.errorFallbackOccurrenceThreshold ?? 5}
        onChange={(value) => onChange("errorFallbackOccurrenceThreshold")(value === "" || value === null || value === undefined ? null : Number(value))}
        type="number"
        min={1}
        max={20}
        isDisabled={!config?.errorFallbackType}
      />

      <InputField
        label="Error Fallback Time Window"
        tooltip="Time window in seconds to track timeout occurrences across sessions. Default: 300 (5 minutes)"
        placeholder="Enter seconds"
        value={config?.errorFallbackTimeWindowSeconds ?? 300}
        onChange={(value) => onChange("errorFallbackTimeWindowSeconds")(value === "" || value === null || value === undefined ? null : Number(value))}
        type="number"
        min={60}
        max={3600}
        isDisabled={!config?.errorFallbackType}
      />
    </View>
  );
};
